<div class="configuration-hints-wrapper">
  <mat-accordion>
    <mat-expansion-panel [ngClass]="{'isOpened': isPanelOpened}" (opened)="onPanelOpen()" (closed)="onPanelClosed()">
      <mat-expansion-panel-header collapsedHeight="44px" expandedHeight="44px">
        <div class="header">
          <ng-container *ngIf="isAllRecomendationDone else failed">
            <mat-icon class="passed-icon">done</mat-icon>
          </ng-container>

          <ng-template #failed>
            <mat-icon class="failed-icon">report_problem</mat-icon>
          </ng-template>
          <mat-panel-title>
            <p class="title">{{'sources.configuration.ConfigurationHints.Title' | translate}}</p>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>
      <div class="content">
        <div class="hints">
          <div class="hint" *ngFor="let hint of adaptedConfigurationHints; let i = index">
            <div class="icon_title" [ngClass]="{ passed: hint.Passed, failed: !hint.Passed }">
              <ng-container *ngIf="hint.Passed; else failed">
                <mat-icon class="passed-icon">done</mat-icon>
              </ng-container>

              <ng-template #failed>
                <mat-icon class="failed-icon">report_problem</mat-icon>
              </ng-template>

              <p class="title">
                <span>{{ hint.TitleKey | translate }}</span>
                <a *ngIf="hint.HelpLink !== null" [href]="hint.HelpLink" target="_blank" class="help-link">
                  <img class="help-link-icon" src="./assets/img/icons/help-link.svg" alt=""/>
                </a>
              </p>
            </div>

            <p class="label">{{ hint.LabelKey | translate }}</p>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
